<template>
  <page-layout
    id="add-class-page"
    :title="$t('grade_scale.update_grade_scale')"
  >
    <main-information
      v-if="childComponentLoader"
      :isDetailPage="true"
      @on-submit="updateGradeScale"
      :gradeScaleData="gradeScaleData"
      ref="formRef"
    >
      <!-- <template #footer-actions>
        <div class="form-actions text-center">
          <md-button class="md-raised" @click="goToPreviousPage"
            >Cancel</md-button
          >
          <md-button type="submit" class="md-success ml-4">Update</md-button>
        </div>
      </template> -->
    </main-information>
  </page-layout>
</template>

<script>
import { MainInformation } from "../Forms";
import PageLayout from "@/pages/PageLayout.vue";
import { service_paths } from "@/constants/Services";
import { Message } from "@/helpers/utils";
import { grade_scale_router_names } from "@/routes/routes";

export default {
  components: { MainInformation, PageLayout },
  data() {
    const gradeScaleId = this.$route.params.id;
    return {
      path: `${service_paths.grade_scales}/${gradeScaleId}`,
      gradeScaleId,
      gradeScaleData: null,
      childComponentLoader: false
    };
  },
  created() {
    this.getGradeScaleInfo();
  },
  methods: {
    getGradeScaleInfo() {
      this.$axios.get(this.path).then(({ data }) => {
        this.gradeScaleData = data;
        this.childComponentLoader = true;
      });
    },
    updateGradeScale(formData) {
      this.$axios.put(this.path, formData).then(({ data }) => {
        Message.success(this.$t("common.edit_success"));
        this.$router.push({ name: grade_scale_router_names.listPage });
      });
    }
    // clearForm() {
    // this.$refs.formRef.clearForm();
    // }
  }
};
</script>
